import api from '../api/config';

export type UserSettings = Record<string, Record<string, string>>;

interface SettingsDefaults {
    [category: string]: Record<string, boolean>;
}

// Keep in sync with the allowlist in backend/src/routes/api/v2/shared/settings-allowlist.ts.
const DEFAULTS: SettingsDefaults = {
    notifications: {
        chat_activity: false,
        digest_emails: true
    }
};

function parseValue(raw: string | undefined, fallback: boolean): boolean {
    if (raw === undefined) return fallback;
    try {
        return JSON.parse(raw);
    } catch {
        return fallback;
    }
}

export function getSettingValue(settings: UserSettings, category: string, key: string): boolean {
    const raw = settings[category]?.[key];
    const fallback = DEFAULTS[category]?.[key] ?? false;
    return parseValue(raw, fallback);
}

export async function fetchSettings(): Promise<UserSettings> {
    const response = await api.get('/user/settings');
    return response.data ?? {};
}

export async function updateSetting(category: string, key: string, value: boolean): Promise<void> {
    await api.post('/user/settings', { category, key, value });
}
